import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [form, setForm]   = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(form.username, form.password);
      signIn(data.token);
      if (data.role === 'superadmin') navigate('/admin');
      else navigate('/dashboard');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.wrap}>
      <div style={styles.card}>
        <div style={styles.logo}>🏪</div>
        <h1 style={styles.title}>TiendaSaaS</h1>
        <p style={styles.sub}>Ingresá a tu cuenta</p>

        {error && <div style={styles.err}>{error}</div>}

        <form onSubmit={handle} style={styles.form}>
          <label style={styles.label}>Usuario</label>
          <input
            style={styles.input}
            type="text"
            autoComplete="username"
            value={form.username}
            onChange={e => setForm({ ...form, username: e.target.value })}
            placeholder="tu usuario"
            required
          />
          <label style={styles.label}>Contraseña</label>
          <input
            style={styles.input}
            type="password"
            autoComplete="current-password"
            value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })}
            placeholder="••••••••"
            required
          />
          <button style={{ ...styles.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'Ingresando...' : 'Ingresar →'}
          </button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  wrap: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f0c29, #1a1a2e, #16213e)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '20px',
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '20px',
    padding: '42px 36px',
    width: '100%', maxWidth: '400px',
    backdropFilter: 'blur(10px)',
  },
  logo: { fontSize: '48px', textAlign: 'center', marginBottom: '12px' },
  title: { color: '#fff', fontSize: '26px', textAlign: 'center', margin: '0 0 4px', fontWeight: 700 },
  sub: { color: 'rgba(255,255,255,0.4)', fontSize: '14px', textAlign: 'center', marginBottom: '28px' },
  err: {
    background: 'rgba(239,68,68,0.15)',
    border: '1px solid rgba(239,68,68,0.3)',
    borderRadius: '10px', padding: '12px 14px',
    color: '#fca5a5', fontSize: '13px', marginBottom: '16px',
  },
  form: { display: 'flex', flexDirection: 'column' },
  label: { color: 'rgba(255,255,255,0.6)', fontSize: '13px', fontWeight: 500, marginBottom: '6px' },
  input: {
    padding: '12px 14px',
    background: 'rgba(255,255,255,0.07)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: '10px', color: '#fff', fontSize: '14px',
    marginBottom: '16px', outline: 'none',
    fontFamily: 'inherit',
  },
  btn: {
    padding: '13px',
    background: 'linear-gradient(135deg, #7c3aed, #4f46e5)',
    border: 'none', borderRadius: '10px',
    color: '#fff', fontSize: '15px', fontWeight: 600,
    cursor: 'pointer', marginTop: '4px',
    fontFamily: 'inherit',
    transition: 'opacity 0.2s',
  },
};
